module.exports = __webpack_public_path__ + "img/menu_icon.5de522ef.svg";